//
// Purpose: SAMB - user table component
// Author: Ronny Van Elewyck
// Version: 1.0
// Creation Date: 04.06.2020
// Modification Date: 04.06.2020
//

// installed components
import React from "react";

// created components
import UserRow from "./userRow";

const UserTable = ({
  listArray,
  changeItem,
  copyItem,
  deleteItem,
  title,
  isUser,
  groupList,
  changePassword,
  changeImage,
  isAdmin,
  isAdminUser,
}) => {
  return (
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead className="thead-light">
          <tr>
            <th></th>
            <th></th>
            {isAdmin && <th></th>}
            {isAdmin && <th></th>}
            <th>{title}</th>
          </tr>
        </thead>
        <tbody>
          {listArray.map((item) => (
            <UserRow
              key={item._id}
              item={item}
              changeItem={changeItem}
              copyItem={copyItem}
              deleteItem={deleteItem}
              isUser={isUser}
              isAdminUser={isAdminUser}
              groupList={groupList}
              changePassword={changePassword}
              changeImage={changeImage}
              isAdmin={isAdmin}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
